export default "__VITE_ASSET__B8ZBcW88__"